import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { initialStateSlice } from "../../initialStateSlice";
// import { fetchAuthPost } from "../../../functions/functions";
import api from "../../../routes/api";
import { fetcher } from "../../../apis";

const pdspSlice = createSlice({
  name: "pdsp",
  initialState: initialStateSlice,
  reducers: {
    set_pdsp: (state, action) => {
      return action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(load_pdsp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(load_pdsp.fulfilled, (state, action) => {
        state.loading = false;
        state.body = action.payload;
      })
      .addCase(load_pdsp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export const { set_pdsp } = pdspSlice.actions;
export default pdspSlice;

export const load_pdsp = createAsyncThunk(
  "reference/pdsp/load_pdsp",
  async (payload, { getState, dispatch }) => {
    // const result = await fetchAuthPost(
    //   api.address.readAllProvinceDistrictSubdistrict,
    //   {}
    // );
    const result = await fetcher({
      route: "/address/allProvinceDistrictSubdistrict",
    });
    if (result.ok) {
      return result.json.data;
    } else {
      throw result.json?.message;
    }
  }
);
